import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import API_URL from '../config';

function getAuthHeader() {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function useMyPeople() {
  return useQuery({
    queryKey: ['my-people'],
    queryFn: async () => {
      const res = await axios.get(`${API_URL}/api/users/my-people`, {
        headers: getAuthHeader(),
      });
      return res.data;
    },
    staleTime: 60000,
  });
}
